import styled from '@emotion/styled'

export const KP11LinkEmailInputStyle = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  // gap: 18px;
`

export const FloatingInputWrapStyle = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  .floating-group {
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
  }
  .floating-group input {
    width: 100%;
    font-family: 'Open Sans', sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0px;
    padding: 8px 0 4px;
    color: #231f20;
    border-bottom: 1px solid #cccccc;
    outline: none;
    transition: border-color 0.1s ease;
  }

  .floating-group input:focus {
    outline: none;
  }

  .floating-group input.error {
    color: #e02020;
  }

  .floating-group label {
    position: absolute;
    left: 4px;
    top: 8px;
    color: #808080;
    font-family: 'Open Sans', sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0;
    pointer-events: none;
    transition: all 0.2s ease;
    background: transparent;
    padding: 0;
    margin: 0;
  }

  .floating-group label.floating {
    top: -12px;
    left: 0px;
    font-size: 12px;
    color: #808080;
  }
  .floating-group-state-icon {
    padding: 4px;
    border-bottom: 1px solid #cccccc;
    outline: none;
  }
`
export const FloatingInputErrorStyle = styled.div`
  .helper-text-wrap {
    margin: 20px 0 0;
    background: #fceaea;
    border-radius: 4px;
    border: 1px solid #ef9595;
    padding: 8px 12px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    // flex-wrap: wrap;
    gap: 16px;
  }
  .helper-text {
    font-family: 'Open Sans', sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0;
    color: #231f20;
  }

  //   .helper-text.error {
  //     color: #e02020;
  //   }

  //   .helper-text.success {
  //     color: green;
  //   }
`
